import * as platformClipboard from '../platform/clipboard';
import { ToastService } from '../platform/notifier';

export const copyToClipboard = (text: unknown): void => {
  if (typeof text !== 'string') return;
  try {
    if (typeof platformClipboard.setClipboardString === 'function') {
      platformClipboard.setClipboardString(text);
    }
  } catch (err) {
    console.warn('[clipboardHelper] copyToClipboard failed:', err);
  }
};

export const getClipboardText = async (): Promise<string> => {
  try {
    if (typeof platformClipboard.getClipboardString === 'function') {
      return await platformClipboard.getClipboardString();
    }
  } catch (err) {
    console.warn('[clipboardHelper] getClipboardText failed:', err);
  }
  return '';
};

export const hasClipboardString = async (): Promise<boolean> => {
  try {
    if (typeof platformClipboard.hasClipboardString === 'function') {
      return await platformClipboard.hasClipboardString();
    }
  } catch (err) {
    console.warn('[clipboardHelper] hasClipboardString failed:', err);
  }
  return false;
};

export const copyWithToast = (
  text?: string,
  message = 'Copied successfully',
): void => {
  if (!text) return;
  try {
    copyToClipboard(text);
    ToastService.show({ type: 'success', message });
  } catch (err) {
    console.warn('[clipboardHelper] copyWithToast failed:', err);
  }
};
